// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"sx_a bht_a bht_r bht_j","Photos__img":"sx_b bht_b"};